// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"24d217a0","453":"770a1dbb","732":"8fddbdd6"}[chunkId] + ".chunk.js";
};